import React from 'react';
import classNames from 'classnames';

import css from './Icons.module.css';

const GlassDisplayIcon = ({ className, viewBox }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="a"
      viewBox="0 0 45.267 44.804"
      className={classNames(css.root, className)}
    >
      <path
        fill="none"
        stroke="#535454"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M1.747 11.906v25.073M30.111 13.948v25.411M43.416 7.365v25.329M15.288 5.221v24.834"
      ></path>
      <path
        fill="none"
        stroke="#535454"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="m13.076 26.351 12.385-4.31M6.075 28.624l3.072-1.07"
      ></path>
      <path
        fill="#535454"
        strokeWidth="0"
        d="m15.086 30.832 24.766 2.624-10.436 5.463-24.051-2.795zm-.256-1.283L1.305 36.911l28.349 3.294 14.436-7.557zM15.744 5.85l24.05 2.364-10.392 5.44L5.39 11.131zm-.242-1.279L1.066 11.934l28.582 3.003L44.084 7.38 15.503 4.57Z"
      ></path>
      <path fill="none" strokeWidth="0" d="M-.016.016h45.189V44.76H-.016z"></path>
    </svg>
  );
};

export default GlassDisplayIcon;
